export const API_BASE_URL = process.env.REACT_APP_MOGZIT_BOOKING_API_BASE_URL;
export const CLOUDINARY_API_URL = process.env.REACT_APP_CLOUDINARY_API_URL;
export const CLOUDINARY_CONFIG_CLOUD_NAME = "mogzit-com";
//export const API_URL = "https://mogzit-booking-api.herokuapp.com/api";
//export const API_URL = "http://localhost:8080/api";
//export const API_URL = "http://192.168.178.28:8080/api";
